












































import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { PostalAddress, PostalCode } from "../../../domain/contact";
import { SelectorDialogMixin } from "../../system/dialogs/mixins";
import { StandardOption } from "../../system/selectors/mixins";
import OptionListBoxSelector from "../../system/selectors/OptionListBoxSelector.vue";
import PostalCodeInput from "../selectors/PostalCodeInput.vue";

@Component({
  components: {
    OptionListBoxSelector,
    PostalCodeInput,
  },
})
export default class PostalAddressPickerDialog extends Mixins(SelectorDialogMixin) {
  @Prop({ default: "郵便番号" })
  name: string;

  $refs!: {
    codeInput: PostalCodeInput,
  };

  data(): any {
    return {
      postalCodePrefix: "",
      filteredOptions: [],
    };
  }
  postalCodePrefix: string;
  filteredOptions: StandardOption<PostalAddress>[];

  get isPostalCodePrefixPickable(): boolean {
    return this.isPickable(this.postalCodePrefix);
  }

  isPickable(source: string): boolean {
    return !!source.match(/^\d{3}-?\d{0,4}$/);
  }

  async pick(postalCodePrefix: string, shouldSelectAutomatically: boolean): Promise<PostalAddress> {
    try {
      this.postalCodePrefix = !!postalCodePrefix ? postalCodePrefix : "";
      await this.updateFilteredOptions();
      if (this.filteredOptions.length === 1 && shouldSelectAutomatically) {
        return this.filteredOptions[0].value;
      }
      return await this.show<PostalAddress>(null);
    } catch (e) {
      throw e;
    }
  }

  /**
   * なぜ受け取った引数をそのまま返却しているのか不明
   * 関連する処理をよく確認しないと何とも言えないが、返却不要なのでは・・？
   */
  async filter(postalCodePrefix: string): Promise<string> {
    try {
      if (!this.isPostalCodePrefixPickable) {
        return postalCodePrefix;
      }

      await this.updateFilteredOptions();

      if (this.filteredOptions.length === 0) {
        this.$warn(
          "該当郵便番号無し",
          "該当する郵便番号が見つかりませんでした。入力内容をご確認ください。"
        );
      }
      return postalCodePrefix;
    } catch (e) {
      throw e;
    }
  }

  private async updateFilteredOptions(): Promise<void> {
    if (this.isPostalCodePrefixPickable) {
      const repository = DomainRegistry.contact.getPostalAddressRepository();
      const postalAddresses = await repository.getEntities(this.postalCodePrefix);
      this.filteredOptions = Enumerable.from(postalAddresses)
        .select(a => Object.freeze(new StandardOption<PostalAddress>(this.toOptionLabelText(a), a)))
        .toArray();
    } else {
      this.filteredOptions = [];
    }
  }

  private toOptionLabelText(source: PostalAddress): string {
    return PostalCode.format(source.postalCode)
      + " "
      + source.prefecture
      + source.municipality
      + source.area;
  }

  @Watch("isVisible")
  onVisibleUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue) {
      this.$nextTick(() => {
        this.focusToPostalCodeInput();
      });
    }
  }

  focusToPostalCodeInput(): void {
    const target = this.$refs.codeInput;
    if (target) {
      target.focusToInput();
    }
  }
}
